"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GeoJsonEditMode", {
  enumerable: true,
  get: function get() {
    return _geojsonEditMode.GeoJsonEditMode;
  }
});
Object.defineProperty(exports, "ModifyMode", {
  enumerable: true,
  get: function get() {
    return _modifyMode.ModifyMode;
  }
});
Object.defineProperty(exports, "TranslateMode", {
  enumerable: true,
  get: function get() {
    return _translateMode.TranslateMode;
  }
});
Object.defineProperty(exports, "ScaleMode", {
  enumerable: true,
  get: function get() {
    return _scaleMode.ScaleMode;
  }
});
Object.defineProperty(exports, "RotateMode", {
  enumerable: true,
  get: function get() {
    return _rotateMode.RotateMode;
  }
});
Object.defineProperty(exports, "DuplicateMode", {
  enumerable: true,
  get: function get() {
    return _duplicateMode.DuplicateMode;
  }
});
Object.defineProperty(exports, "ExtendLineStringMode", {
  enumerable: true,
  get: function get() {
    return _extendLineStringMode.ExtendLineStringMode;
  }
});
Object.defineProperty(exports, "SplitPolygonMode", {
  enumerable: true,
  get: function get() {
    return _splitPolygonMode.SplitPolygonMode;
  }
});
Object.defineProperty(exports, "ExtrudeMode", {
  enumerable: true,
  get: function get() {
    return _extrudeMode.ExtrudeMode;
  }
});
Object.defineProperty(exports, "ElevationMode", {
  enumerable: true,
  get: function get() {
    return _elevationMode.ElevationMode;
  }
});
Object.defineProperty(exports, "TransformMode", {
  enumerable: true,
  get: function get() {
    return _transformMode.TransformMode;
  }
});
Object.defineProperty(exports, "DrawPointMode", {
  enumerable: true,
  get: function get() {
    return _drawPointMode.DrawPointMode;
  }
});
Object.defineProperty(exports, "DrawLineStringMode", {
  enumerable: true,
  get: function get() {
    return _drawLineStringMode.DrawLineStringMode;
  }
});
Object.defineProperty(exports, "DrawPolygonMode", {
  enumerable: true,
  get: function get() {
    return _drawPolygonMode.DrawPolygonMode;
  }
});
Object.defineProperty(exports, "DrawRectangleMode", {
  enumerable: true,
  get: function get() {
    return _drawRectangleMode.DrawRectangleMode;
  }
});
Object.defineProperty(exports, "DrawCircleByDiameterMode", {
  enumerable: true,
  get: function get() {
    return _drawCircleByDiameterMode.DrawCircleByDiameterMode;
  }
});
Object.defineProperty(exports, "DrawCircleFromCenterMode", {
  enumerable: true,
  get: function get() {
    return _drawCircleFromCenterMode.DrawCircleFromCenterMode;
  }
});
Object.defineProperty(exports, "DrawEllipseByBoundingBoxMode", {
  enumerable: true,
  get: function get() {
    return _drawEllipseByBoundingBoxMode.DrawEllipseByBoundingBoxMode;
  }
});
Object.defineProperty(exports, "DrawEllipseUsingThreePointsMode", {
  enumerable: true,
  get: function get() {
    return _drawEllipseUsingThreePointsMode.DrawEllipseUsingThreePointsMode;
  }
});
Object.defineProperty(exports, "DrawRectangleUsingThreePointsMode", {
  enumerable: true,
  get: function get() {
    return _drawRectangleUsingThreePointsMode.DrawRectangleUsingThreePointsMode;
  }
});
Object.defineProperty(exports, "Draw90DegreePolygonMode", {
  enumerable: true,
  get: function get() {
    return _draw90degreePolygonMode.Draw90DegreePolygonMode;
  }
});
Object.defineProperty(exports, "DrawPolygonByDraggingMode", {
  enumerable: true,
  get: function get() {
    return _drawPolygonByDraggingMode.DrawPolygonByDraggingMode;
  }
});
Object.defineProperty(exports, "ImmutableFeatureCollection", {
  enumerable: true,
  get: function get() {
    return _immutableFeatureCollection.ImmutableFeatureCollection;
  }
});
Object.defineProperty(exports, "ViewMode", {
  enumerable: true,
  get: function get() {
    return _viewMode.ViewMode;
  }
});
Object.defineProperty(exports, "MeasureDistanceMode", {
  enumerable: true,
  get: function get() {
    return _measureDistanceMode.MeasureDistanceMode;
  }
});
Object.defineProperty(exports, "MeasureAreaMode", {
  enumerable: true,
  get: function get() {
    return _measureAreaMode.MeasureAreaMode;
  }
});
Object.defineProperty(exports, "MeasureAngleMode", {
  enumerable: true,
  get: function get() {
    return _measureAngleMode.MeasureAngleMode;
  }
});
Object.defineProperty(exports, "CompositeMode", {
  enumerable: true,
  get: function get() {
    return _compositeMode.CompositeMode;
  }
});
Object.defineProperty(exports, "SnappableMode", {
  enumerable: true,
  get: function get() {
    return _snappableMode.SnappableMode;
  }
});
Object.defineProperty(exports, "_memoize", {
  enumerable: true,
  get: function get() {
    return _memoize["default"];
  }
});
exports.utils = void 0;

var _geojsonEditMode = require("./lib/geojson-edit-mode");

var _modifyMode = require("./lib/modify-mode");

var _translateMode = require("./lib/translate-mode");

var _scaleMode = require("./lib/scale-mode");

var _rotateMode = require("./lib/rotate-mode");

var _duplicateMode = require("./lib/duplicate-mode");

var _extendLineStringMode = require("./lib/extend-line-string-mode");

var _splitPolygonMode = require("./lib/split-polygon-mode");

var _extrudeMode = require("./lib/extrude-mode");

var _elevationMode = require("./lib/elevation-mode");

var _transformMode = require("./lib/transform-mode");

var _drawPointMode = require("./lib/draw-point-mode");

var _drawLineStringMode = require("./lib/draw-line-string-mode");

var _drawPolygonMode = require("./lib/draw-polygon-mode");

var _drawRectangleMode = require("./lib/draw-rectangle-mode");

var _drawCircleByDiameterMode = require("./lib/draw-circle-by-diameter-mode");

var _drawCircleFromCenterMode = require("./lib/draw-circle-from-center-mode");

var _drawEllipseByBoundingBoxMode = require("./lib/draw-ellipse-by-bounding-box-mode");

var _drawEllipseUsingThreePointsMode = require("./lib/draw-ellipse-using-three-points-mode");

var _drawRectangleUsingThreePointsMode = require("./lib/draw-rectangle-using-three-points-mode");

var _draw90degreePolygonMode = require("./lib/draw-90degree-polygon-mode");

var _drawPolygonByDraggingMode = require("./lib/draw-polygon-by-dragging-mode");

var _immutableFeatureCollection = require("./lib/immutable-feature-collection");

var _viewMode = require("./lib/view-mode");

var _measureDistanceMode = require("./lib/measure-distance-mode");

var _measureAreaMode = require("./lib/measure-area-mode");

var _measureAngleMode = require("./lib/measure-angle-mode");

var _compositeMode = require("./lib/composite-mode");

var _snappableMode = require("./lib/snappable-mode");

var _memoize = _interopRequireDefault(require("./memoize"));

var utils = _interopRequireWildcard(require("./utils"));

exports.utils = utils;

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}